import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "./Blog.css";

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchBlog();
    } else {
      setError("Invalid blog ID");
      setLoading(false);
    }
  }, [id]);

  const fetchBlog = async () => {
    try {
      console.log("Fetching blog with ID:", id); // Debug log

      const response = await fetch(
        `https://ambatturindustrialestate.com/api/api/blogs/${id}/`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Blog detail API Response:", data); // Debug log

      setBlog(data);
    } catch (err) {
      console.error("Error fetching blog:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="blog-loading">Loading blog...</div>;
  if (error)
    return (
      <div className="blog-detail-container">
        <div className="blog-error">
          Error: {error}
          <br />
          <button onClick={() => navigate("/blogs")} className="blog-back-btn">
            Back to Blogs
          </button>
        </div>
      </div>
    );
  if (!blog)
    return (
      <div className="blog-detail-container">
        <div className="blog-error">
          Blog not found
          <br />
          <button onClick={() => navigate("/blogs")} className="blog-back-btn">
            Back to Blogs
          </button>
        </div>
      </div>
    );

  return (
    <div className="blog-detail-container">
      <div className="blog-detail-header">
        <button onClick={() => navigate("/blogs")} className="blog-back-btn">
          ← Back to Blogs
        </button>
        <div className="blog-detail-actions">
          <Link to={`/blogs/edit/${blog.id}`} className="blog-edit-btn">
            Edit Blog
          </Link>
        </div>
      </div>

      <article className="blog-detail">
        {blog.image && (
          <div className="blog-detail-image">
            <img
              src={blog.image}
              alt={blog.title}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        )}

        <div className="blog-detail-content">
          <h1 className="blog-detail-title">{blog.title || "Untitled Blog"}</h1>

          <div className="blog-detail-meta">
            <span className="blog-detail-category">
              {blog.category_name || blog.category || "Uncategorized"}
            </span>
            <span className="blog-detail-author">
              By {blog.author || "Unknown"}
            </span>
            {blog.hint && (
              <span className="blog-detail-hint">Hint: {blog.hint}</span>
            )}
          </div>

          <div className="blog-detail-description">
            {blog.description ? (
              blog.description
                .split("\n")
                .map((paragraph, index) => <p key={index}>{paragraph}</p>)
            ) : (
              <p>No content available.</p>
            )}
          </div>
        </div>
      </article>
    </div>
  );
};

export default BlogDetail;
